<script>
import { Table } from 'element-ui'
export default {
    extends: Table,
    inject: ['tableGlobal' ],
    methods: {
         // TODO 使用 CSS transform
      syncPostion() {
        const { scrollLeft, scrollTop, offsetWidth, scrollWidth } = this.bodyWrapper;
        this.tableGlobal.bodyWrapperData =  { scrollLeft, scrollTop, offsetWidth, scrollWidth };
        this.tableGlobal.$refs.tableHeaderRef.syncPostion()
        const { headerWrapper, footerWrapper, fixedBodyWrapper, rightFixedBodyWrapper } = this.$refs;
        if (headerWrapper) headerWrapper.scrollLeft = scrollLeft;
        if (footerWrapper) footerWrapper.scrollLeft = scrollLeft;
        if (fixedBodyWrapper) fixedBodyWrapper.scrollTop = scrollTop;
        if (rightFixedBodyWrapper) rightFixedBodyWrapper.scrollTop = scrollTop;
        const maxScrollLeftPosition = scrollWidth - offsetWidth - 1;
        if (scrollLeft >= maxScrollLeftPosition) {
          this.scrollPosition = 'right';
        } else if (scrollLeft === 0) {
          this.scrollPosition = 'left';
        } else {
          this.scrollPosition = 'middle';
        }
      },
    },
    watch: {
      bodyWidth: {
        handler(newVal) {
          this.$emit('update:width', newVal);
        },
        immediate: true
      }
    }
}
</script>